<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-card>
          <b-form-group
            label="Müşteri Ara"
            label-for="search"
          >
            <b-form-input
              id="search"
              v-model="search"
              placeholder="Müşteri Adı, Firma Adı, Telefon No"
              @keydown.enter="searchData"
            />
          </b-form-group>
          <div class="text-center">
            <b-button
              type="submit"
              variant="primary"
              class="mr-50"
              @click="searchData"
            >
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              Ara
            </b-button>
            <b-button
              variant="danger"
              to="/admin/customers/add/"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              Müşteri Kartı Ekle
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col md="8">
        <b-card no-body>
          <b-table
            striped
            hover
            responsive
            :fields="fields"
            :items="customers"
          >
            <template #cell(name)="data">
              <div>{{ data.item.company }}</div>
            </template>
            <template #cell(phone)="data">
              {{ data.item.phone }}
            </template>
            <template #cell(control)="data">
              <b-button
                :to="'/customer-payment/' + data.item.id"
                variant="outline-primary"
                block
                size="sm"
              >
                Ödeme Al / Yap
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BFormGroup, BFormInput, BRow, BTable, VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'CustomerSearch',
  components: {
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    BCard,
    BTable,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      search: null,
      fields: [
        {
          key: 'name',
          label: 'Müşteri',
        },
        {
          key: 'phone',
          label: 'Telefon',
          thStyle: { width: '200px', textAlign: 'left', verticalAlign: 'middle' },
        },
        {
          key: 'control',
          label: 'Kontrol',
          thStyle: { width: '200px', textAlign: 'left', verticalAlign: 'middle' },
        },
      ],
      dataQuery: {
        select: [
          'customers.id AS id',
          'customers.company AS company',
          'customers.phone AS phone',
          'customers.email AS email',
        ],
        order_by: ['id', 'DESC'],
        limit: 10,
        start: 0,
      },
    }
  },
  computed: {
    customers() {
      return this.$store.getters['customers/dataList']
    },
  },
  created() {
    this.getCustomer()
  },
  methods: {
    searchData() {
      this.dataQuery.or_like = {
        'customers.company': this.search,
        'customers.phone': this.search,
      }
      this.getCustomer()
    },
    getCustomer() {
      if (this.userData.id_customers) {
        this.$router.push('/payment')
      }
      this.$store.dispatch('customers/getDataList', this.dataQuery)
    },
  },
}
</script>
